import { FC } from 'react'
import { NewHeader } from 'components/page-header'
import { useTranslation } from 'react-i18next'

export const Header: FC = () => {
  const { t } = useTranslation()

  return <NewHeader title={t('common.employees')} />
}
